import { KIND } from 'baseui/button'

const pulseBorder = color => ({
  borderTopWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderRightWidth: '1px',
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
  borderLeftStyle: 'solid',
  borderRightStyle: 'solid',
  borderTopColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderRightColor: color,
})

const PULSE_TONES = {
  primary: { background: 'primaryPulse', text: 'white', border: 'primaryPulse', hover: 'primaryPulseHover' },
  secondary: { background: 'white', text: 'textPulseStrong', border: 'borderPulse', hover: 'bgPulseCanvas' },
  danger: {
    background: 'dangerPulseSoftBg',
    text: 'dangerPulseStrongText',
    border: 'dangerPulseBorder',
    hover: 'dangerPulseBorder',
  },
}

const resolveTone = ($kind, tone) => {
  if (tone) return tone
  return $kind === KIND.secondary ? 'secondary' : 'primary'
}

const pulseKindStyle = ($theme, $kind, tone) => {
  const { background, text, border, hover } = PULSE_TONES[resolveTone($kind, tone)]
  const colors = { backgroundColor: $theme.colors[background], color: $theme.colors[text] }

  return {
    ...colors,
    ...pulseBorder($theme.colors[border]),
    ':hover': { backgroundColor: $theme.colors[hover] },
    // BaseUI greys a disabled button out through :disabled; PULSE keeps its colours at half opacity.
    ':disabled': { ...colors, opacity: 0.5, cursor: 'default' },
  }
}

export const pulseButtonStyle = ($theme, $kind, tone) => ({
  height: '38px',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: '16px',
  paddingRight: '16px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottomRightRadius: '8px',
  borderBottomLeftRadius: '8px',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  ...pulseKindStyle($theme, $kind, tone),
})

export const SDButtonOverrides = (block, isPulse = false, tone = undefined) => {
  return {
    BaseButton: {
      style: ({ $theme, $kind }) => ({
        width: block ? '100%' : 'auto',

        borderTopLeftRadius: $theme.borders.radius200,
        borderTopRightRadius: $theme.borders.radius200,
        borderBottomRightRadius: $theme.borders.radius200,
        borderBottomLeftRadius: $theme.borders.radius200,

        fontFamily: $theme.typography.font550.fontFamily,
        fontWeight: 600,
        ...(isPulse ? pulseButtonStyle($theme, $kind, tone) : {}),
      }),
    },
  }
}
